import { DeleteModal, DeleteModalProps } from 'src/common/DeleteModal';

export const TripRejectRequestModal = ({
  props,
}: {
  props: DeleteModalProps;
}) => {
  return <DeleteModal {...props} />;
};
